// extracted by mini-css-extract-plugin
export var dropdown = "_tk-0";
export var imageWrapper = "_tk-3";
export var itemNameContainer = "_tk-1";
export var productImage = "_tk-2";
export var spinnerWrapper = "_tk-4";